import React from 'react';
import { Loader2 } from 'lucide-react';
import { PageLoadingIndicator, PageLoadingSpinner } from '@kioskgaming/page-loading';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className }) => (
  <PageLoadingSpinner size={size} className={className} />
);

interface LoadingOverlayProps {
  isLoading: boolean;
  children: React.ReactNode;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  children,
  message = 'Loading...',
}) => {
  if (!isLoading) return <>{children}</>;

  return (
    <div className="relative">
      {children}
      <div
        className="absolute inset-0 z-50 flex items-center justify-center bg-background/50"
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label={message}
      >
        <div className="flex flex-col items-center gap-3 rounded-lg border border-border bg-card px-8 py-6 shadow-lg">
          <Loader2 className="h-10 w-10 animate-spin text-primary" strokeWidth={2} aria-hidden />
          <p className="text-sm font-medium text-foreground">{message}</p>
        </div>
      </div>
    </div>
  );
};

interface LoadingPageProps {
  message?: string;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ message = 'Loading...' }) => (
  <PageLoadingIndicator
    variant="fullscreen"
    label={message}
    spinnerClassName="text-muted-foreground"
    labelClassName="text-lg text-muted-foreground"
  />
);

export { LoadingSpinner, LoadingOverlay, LoadingPage };
